import { CSSProperties } from 'react';

export const MK3_COLORS = {
  heading: '#39264F',
  accent: '#573A78',
  cardBg: '#F5F3F7',
  cardBorder: '#BCB0C9',
  pageBg: '#E6E1EB',
} as const;

export const cardShellStyle: CSSProperties = {
  background: MK3_COLORS.cardBg,
  border: `1px solid ${MK3_COLORS.cardBorder}`,
  boxShadow: '2px 2px 5px rgba(24,0,100,0.15)',
};

export const headlineStyle: CSSProperties = {
  fontFamily: 'Grift, sans-serif',
  fontWeight: 700,
  fontSize: 19,
  lineHeight: '22px',
  color: MK3_COLORS.heading,
};

export const bodyStyle: CSSProperties = {
  fontFamily: 'Grift, sans-serif',
  fontWeight: 500,
  fontSize: 15,
  lineHeight: '20px',
  color: '#895BBE',
};

// Figma "M - PRIMARY BUTTON" component (e.g. node 40001093:16488) — 398x65,
// full pill, gradient-edge border, Grift Bold 19px. Every onboarding CTA pill
// uses this single shared style, so this is the one place to keep in sync.
export const primaryButtonStyle: CSSProperties = {
  background: '#AB72ED',
  border: '1px solid #CDAAF4',
  boxShadow: '2px 2px 5px rgba(24,0,100,0.15)',
  borderRadius: 100,
  height: 65,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontFamily: 'Grift, sans-serif',
  fontWeight: 700,
  fontSize: 19,
  lineHeight: '22px',
  letterSpacing: 1,
  color: '#F7F5F8',
  textShadow: '0px 2px 4px rgba(0,0,0,0.05)',
};

// Figma "Title Subtitle" blocks (e.g. node 40001093:16488) wrap the body copy
// to ~2 short centered lines rather than one long line across the full card
// width. Spread this alongside bodyStyle on every screen's subtitle paragraph:
// style={{ ...bodyStyle, ...subtitleStyle }}.
export const subtitleStyle: CSSProperties = {
  maxWidth: 300,
  marginLeft: 'auto',
  marginRight: 'auto',
};

export const footerNoteStyle: CSSProperties = {
  fontFamily: 'Grift, sans-serif',
  fontWeight: 400,
  fontSize: 13,
  lineHeight: '17px',
  letterSpacing: 0.5,
  color: '#895BBE',
};

// Outline pill used as the second choice under a primaryButtonStyle pill
// (Your Turn, First Document).
export const secondaryPillButtonStyle: CSSProperties = {
  ...primaryButtonStyle,
  background: 'transparent',
  border: `1.5px solid ${MK3_COLORS.accent}`,
  boxShadow: 'none',
  textShadow: 'none',
  color: MK3_COLORS.accent,
};

// Underlined text link under the pills (Your Turn's demo link, First
// Document's "do it later").
export const demoLinkStyle: CSSProperties = {
  fontFamily: 'Grift, sans-serif',
  fontWeight: 600,
  fontSize: 15,
  color: '#573A78',
  textDecoration: 'underline',
  padding: '8px 12px',
};
